module.exports = __webpack_public_path__ + "img/ava-5.1ac76d07.webp";